import { AxiosInstance } from 'axios'
import { Notification, ListNotificationsResponse, ListNotificationsParams } from './notification.type'

export class NotificationApi {
    constructor(private readonly client: AxiosInstance) {}

    /**
     * Get general notifications
     */
    async list(params?: ListNotificationsParams): Promise<ListNotificationsResponse> {
        const response = await this.client.get<ListNotificationsResponse>('/notifications', { params })
        return response.data
    }

    /**
     * Get approval notifications
     */
    async listApprovals(params?: ListNotificationsParams): Promise<ListNotificationsResponse> {
        const response = await this.client.get<ListNotificationsResponse>('/notifications/approvals', { params })
        return response.data
    }

    /**
     * Get warning notifications
     */
    async listWarnings(params?: ListNotificationsParams): Promise<ListNotificationsResponse> {
        const response = await this.client.get<ListNotificationsResponse>('/notifications/warnings', { params })
        return response.data
    }

    /**
     * Toggle read status for a notification
     */
    async toggleRead(id: string, isRead: boolean): Promise<Notification> {
        const response = await this.client.put<Notification>(`/notifications/${id}/toggle-read`, { isRead })
        return response.data
    }

    /**
     * Mark all notifications as read
     */
    async markAllAsRead(): Promise<void> {
        await this.client.put('/notifications/mark-all-as-read')
    }
}
